import React from 'react';

import { useState, useEffect } from 'react';
import { Dialog, DialogActions, DialogTitle } from '@mui/material';

const FullPageIframe = ({ url, onTimeout, brandColor, brandFont, menuPopup }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const intervalTime = menuPopup * 1000;
    const timer = setTimeout(() => {
      setModalOpen(true);
    }, intervalTime); // 1 minute = 60000ms

    return () => clearTimeout(timer);
  }, [modalOpen]); // Added modalOpen dependency to restart timer

  useEffect(() => {
    if (modalOpen && countdown > 0) {
      const timer = setInterval(() => {
        setCountdown(prev => prev - 1);
      }, 1000);
      return () => clearInterval(timer);
    } else if (countdown === 0) {
      handleCountdownComplete();
    }
  }, [modalOpen, countdown]);

  const handleCountdownComplete = () => {
    console.log('Countdown finished! Performing timeout action.');
    setModalOpen(false);
    setCountdown(5);
    if (onTimeout) {
      onTimeout();
    }
  };

  const handleModalClose = () => {
    setModalOpen(false);
    setCountdown(5);
  };

  const handleBackdropClick = () => {
    handleModalClose();
  };

  return (
    <>
      <div
        style={{
          width: '100vw',
          height: '100vh',
          overflow: 'hidden',
          position: 'absolute',
          zIndex: '2',
        }}
      >
        <iframe
          src={url}
          title="External Page"
          sandbox="allow-scripts allow-same-origin"
          loading="lazy"
          style={{
            width: '100vw',
            height: '100vh',
            border: 'none',
          }}
        />
      </div>

      <Dialog
        open={modalOpen}
        onClose={handleModalClose}
        BackdropProps={{
          onClick: handleBackdropClick,
        }}
        sx={{
          '& .MuiDialog-paper': {
            backgroundColor: '#FFFFFF',
            border: `2px solid ${brandColor}`,
            padding: `2vw`,
            borderRadius: '20px',
            width: '55vw',
          },
          '& .MuiBackdrop-root': {
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
          },
        }}
      >
        <DialogTitle
          style={{
            textAlign: 'center',
            fontSize: `3vw`,
            fontFamily: brandFont,
          }}
        >
          Are You There?
        </DialogTitle>

        <DialogTitle
          style={{
            textAlign: 'center',
            fontSize: `3vw`,
            fontFamily: brandFont,
          }}
        >
          {countdown}
        </DialogTitle>

        <DialogActions>
          <button
            style={{
              margin: '0 auto',
              background: brandColor,
              fontFamily: brandFont,
              fontSize: `2vw`,
              height: '6vh',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              padding: '0 20px',
            }}
            onClick={handleModalClose}
          >
            Yes
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default FullPageIframe;
